import type { ReactNode } from 'react';

export const symbol_heap_snapshot_large: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M580.5-230q20.5 0 35-15t14.5-35.5q0-20.5-14.58-35Q600.83-330 580-330q-20 0-35 14.58-15 14.59-15 35.42 0 20 15 35t35.5 15ZM378-248q12 0 21-9l204-204q9-9 9-21t-9-21q-9-9-21-9t-21 9L357-299q-9 9-9 21t9 21q9 9 21 9Zm2.5-182q20.5 0 35-15t14.5-35.5q0-20.5-14.58-35Q400.83-530 380-530q-20 0-35 14.58-15 14.59-15 35.42 0 20 15 35t35.5 15ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-614v-126H220v680h520v-494H611q-24.75 0-42.37-17.63Q551-669.25 551-694ZM220-820v186-186 680-680Z"
		/>
	</svg>
);
